import { RefreshRounded as RefreshRoundedIcon } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { t } from 'i18next'
import { useState } from 'react'

import ChangeOrganization from '../../Organizations/Dialogs/ChangeOrganization'
import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'

const ChangeOrganizationToggle = () => {
  const { refreshSelfOrganizations } = useAuth()
  const [isChangeOrganizationDialogOpen, setIsChangeOrganizationDialogOpen] =
    useState(false)

  const handleClick = () => {
    refreshSelfOrganizations()
    setIsChangeOrganizationDialogOpen(true)
  }

  return (
    <>
      <IconButton
        id="change-organization-toggle"
        aria-label={`${t('organizations.changeOrganization')}`}
        color="primary"
        onClick={handleClick}
      >
        <RefreshRoundedIcon fontSize="small" />
      </IconButton>

      <ChangeOrganization
        isOpen={isChangeOrganizationDialogOpen}
        setIsOpen={setIsChangeOrganizationDialogOpen}
      />
    </>
  )
}

export default ChangeOrganizationToggle
